// extracted by mini-css-extract-plugin
export default {"brand_name_box":"styles_brand_name_box__KoZrt"};